import React from "react";
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";

export function LogoutModal(props) {
  const { open, mainColor, mainColorHover, closeModal, logout } = props;

  const ColorButton = withStyles((theme) => ({
    root: {
      fontSize: "16px",
      lineHeight: "1",
      color: "white",
      outline: "none",
      backgroundColor: mainColor,
      boxShadow: "none",
      padding: "0.8rem 0.8rem",
      "&:hover": {
        backgroundColor: mainColorHover,
      },
      "&:focus": { outline: "none", boxShadow: "none" },
      "&:active": { outline: "none", boxShadow: "none" },
    },
  }))(Button);

  const WhiteButton = withStyles((theme) => ({
    root: {
      fontSize: "16px",
      lineHeight: "1",
      color: mainColor,
      backgroundColor: "transparent",
      border: "0px solid",
      borderColor: mainColor,
      boxShadow: "none",
      "&:hover": { backgroundColor: "#f2f2f2" },
      padding: "0.8rem 0.8rem",
      "&:focus": { outline: "none", boxShadow: "none" },
      "&:active": { outline: "none", boxShadow: "none" },
    },
  }))(Button);

  return (
    <Modal open={open} showCloseIcon={false}  center style={{borderRadius:'10px'}}>
      <div className="v2-modal">
        <p>Are you sure you want to logout of your account?</p>

        <div 
        style={{
          display: "flex",
          flexDirection: "row-reverse",
          justifyContent:" space-between"
        }}
        className="form-container-footer layout-spread layout-spread-buttons modal-logout-buttons">
          <div >
            <WhiteButton variant="contained" onClick={closeModal}>
              Cancel
            </WhiteButton>
            <ColorButton variant="contained" onClick={logout}>
              Logout
            </ColorButton>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default LogoutModal;
